export default {"src":"/_next/static/media/avatar.e6a00c56.svg","height":532,"width":532,"blurWidth":0,"blurHeight":0};